Whether the candidate's identity has been verified.
